module.exports = __webpack_public_path__ + "files/f90e0a7c8d32e0a4c735973f0d3b3a8a.png";